import { useEffect, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DeviceMobileCamera } from "@phosphor-icons/react";

// QR-Code für Handy-Scan; pollt die Sitzung und meldet den Empfang.
export function MobileScanQR({ documentId = null, label = "", onReceived, size = "sm", testId = "mobile-scan-btn" }) {
  const [open, setOpen] = useState(false);
  const [session, setSession] = useState(null);
  const [status, setStatus] = useState("open");
  const timer = useRef(null);

  const start = async () => {
    try {
      const { data } = await api.post("/messages/scan-sessions", { document_id: documentId, label });
      setSession(data);
      setStatus("open");
      setOpen(true);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "QR-Code konnte nicht erzeugt werden");
    }
  };

  useEffect(() => {
    if (!open || !session?.token) return undefined;
    timer.current = setInterval(async () => {
      try {
        const { data } = await api.get(`/messages/scan-sessions/${session.token}`);
        setStatus(data.status);
        if (data.status === "completed") {
          clearInterval(timer.current);
          toast.success(`${data.pages} Seite${data.pages === 1 ? "" : "n"} vom Handy empfangen`);
          onReceived?.({ id: data.scan_id, pages: data.pages, size: data.size, names: "Handy-Scan" });
          setOpen(false);
        } else if (data.status === "expired") {
          clearInterval(timer.current);
        }
      } catch { /* weiter pollen */ }
    }, 2500);
    return () => clearInterval(timer.current);
  }, [open, session?.token]); // eslint-disable-line react-hooks/exhaustive-deps

  const url = session ? `${window.location.origin}/handy-scan/${session.token}` : "";
  return (
    <>
      <Button size={size} variant="outline" onClick={start} className="gap-1.5" data-testid={testId}>
        <DeviceMobileCamera size={14} /> Mit Handy scannen
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="mobile-scan-dialog">
          <DialogHeader>
            <DialogTitle>Mit dem Handy scannen</DialogTitle>
            <DialogDescription>
              QR-Code mit der Handy-Kamera scannen, Seiten fotografieren und übertragen. Der Link gilt 30 Minuten.
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center gap-3 py-2">
            {url && <QRCodeSVG value={url} size={220} level="M" data-testid="mobile-scan-qr" />}
            <div className="text-[11px] text-slate-500 break-all text-center" data-testid="mobile-scan-url">{url}</div>
            <div className={`text-xs ${status === "expired" ? "text-rose-700" : "text-slate-600"}`} data-testid="mobile-scan-status">
              {status === "expired" ? "Link abgelaufen — bitte neu erzeugen." : "Warte auf Fotos vom Handy …"}
            </div>
            {status === "expired" && <Button size="sm" onClick={start}>Neuen QR-Code erzeugen</Button>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
